import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "../lib/site";

export default function MobileStickyBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-inkline bg-warmwhite/95 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      role="navigation"
      aria-label="Quick actions"
    >
      <div className="grid grid-cols-2 gap-2 px-3 py-2.5">
        <a
          href={SITE.phoneHref}
          data-testid="mobile-sticky-call-button"
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-forest px-4 text-[0.92rem] font-medium text-ivory transition-colors active:bg-forest-dark"
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          Call Doris
        </a>
        <Link
          to="/contact"
          data-testid="mobile-sticky-talk-button"
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-forest/30 px-4 text-[0.92rem] font-medium text-forest transition-colors active:bg-forest/5"
        >
          <MessageCircle className="h-4 w-4" aria-hidden="true" />
          Talk With Doris
        </Link>
      </div>
    </div>
  );
}
